class HpgComparison extends HTMLElement {
  connectedCallback() {
    this.selected = new Map();
    this.controller = new AbortController();
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-hpg-compare]');
      if (!button) return;
      let product;
      try { product = JSON.parse(button.dataset.hpgCompare); } catch { return; }
      const id = String(product.id);
      if (this.selected.has(id)) this.selected.delete(id);
      else if (this.selected.size < 3) this.selected.set(id, product);
      else { this.querySelector('[data-compare-status]').textContent = 'Three products selected. Remove one before adding another.'; return; }
      this.render();
    }, {signal: this.controller.signal});
    this.querySelector('[data-compare-clear]').addEventListener('click', () => { this.selected.clear(); this.render(); });
    this.render();
  }
  disconnectedCallback() { this.controller.abort(); }
  render() {
    document.querySelectorAll('[data-hpg-compare]').forEach(button => {
      try { button.setAttribute('aria-pressed', String(this.selected.has(String(JSON.parse(button.dataset.hpgCompare).id)))); } catch { /* Ignore malformed data. */ }
    });
    const products = [...this.selected.values()], region = this.querySelector('[data-compare-table]');
    region.replaceChildren(); region.hidden = !products.length;
    this.querySelector('[data-compare-clear]').hidden = !products.length;
    this.querySelector('[data-compare-status]').textContent = products.length ? `${products.length} of 3 products selected. Scroll the comparison horizontally on a small screen.` : 'No products selected.';
    if (!products.length) return;
    const table = document.createElement('table'), caption = document.createElement('caption');
    caption.textContent = 'Selected products — confirm exact package and equipment requirements'; table.append(caption);
    const head = document.createElement('thead'), heading = document.createElement('tr'), corner = document.createElement('th'); corner.textContent = 'Compare'; corner.scope = 'col'; heading.append(corner);
    for (const p of products) {
      const th = document.createElement('th'), link = document.createElement('a'), remove = document.createElement('button'); th.scope = 'col';
      link.href = p.url; link.textContent = p.title; remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', `Remove ${p.title} from comparison`);
      remove.addEventListener('click', () => { this.selected.delete(String(p.id)); this.render(); }); th.append(link, remove); heading.append(th);
    }
    head.append(heading); table.append(head); const body = document.createElement('tbody');
    const rows = [['Current price','price'],['Availability',p => p.hold ? 'Ordering paused — source/detail review' : p.available ? 'Available to order' : 'Sold out'],['Listed format / quantity','size'],['Project process','method'],['Model','model'],['Limitations / checks','limitation']];
    for (const [label,key] of rows) {
      const row = document.createElement('tr'), th = document.createElement('th'); th.scope = 'row'; th.textContent = label; row.append(th);
      for (const p of products) { const td = document.createElement('td'); td.textContent = (typeof key === 'function' ? key(p) : p[key]) || 'Not established'; row.append(td); } body.append(row);
    }
    table.append(body); region.append(table);
  }
}
if (!customElements.get('hpg-comparison')) customElements.define('hpg-comparison', HpgComparison);

class HpgSheetPlanner extends HTMLElement {
  connectedCallback() {
    this.addEventListener('input', () => this.calculate()); this.calculate();
  }
  calculate() {
    const values = Object.fromEntries([...this.querySelectorAll('input')].map(el => [el.name,Number(el.value)]));
    const {sheetWidth:sw,sheetHeight:sh,designWidth:dw,designHeight:dh,gap:g,margin:m} = values;
    const out = this.querySelector('output');
    if (![sw,sh,dw,dh].every(v => Number.isFinite(v) && v > 0) || ![g,m].every(v => Number.isFinite(v) && v >= 0)) { out.textContent = 'Enter positive widths and heights, with a nonnegative gap and margin.'; return; }
    const w = Math.max(0,sw-2*m), h = Math.max(0,sh-2*m);
    const fit = (a,b) => Math.floor((w+g)/(a+g))*Math.floor((h+g)/(b+g));
    const straight = fit(dw,dh), rotated = fit(dh,dw), best = Math.max(straight,rotated);
    out.textContent = `${best} rectangular designs per sheet in a uniform grid (${straight} unrotated; ${rotated} rotated). ${best ? 'Reserve material for test cuts and errors.' : 'The design does not fit these usable dimensions.'}`;
  }
}
if (!customElements.get('hpg-sheet-planner')) customElements.define('hpg-sheet-planner', HpgSheetPlanner);
